module.exports = __webpack_public_path__ + "static/media/r_itdot_17.edf46326.png";